import { Injectable } from '@angular/core';
import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { SiteConfigService } from '@services/site-config.service';
import { Logger } from '@utils/logger';
import { Apollo } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import {
  FundDataServiceParams,
  GraphQLFundDataService,
} from './graphql-fund-data.service';
import { Observable } from 'rxjs';
import { MoneyFundLiquidityDTO } from '@types';
import { MoneyFundLiquidity } from '@products/models/money-fund-liquidity';
import { MoneyFundLiquiditiesMapper } from '@products/utils/mappers/money-fund-liquidities.type.mapper';
import { MapperParams } from '@products/utils/mappers/type.mapper';
import { map } from 'rxjs/operators';

const logger = Logger.getLogger('PricingHistoryService');

@Injectable({
  providedIn: 'root',
})
export class MoneyFundLiquidityService extends GraphQLFundDataService {
  constructor(
    apollo: Apollo,
    siteConfigService: SiteConfigService,
    private mapperFactory: MapperFactory
  ) {
    super(apollo, siteConfigService);
  }

  public register(
    query: DocumentNode,
    fundDataServiceParams: FundDataServiceParams
  ): Observable<any> {
    return super.register(query, this.getVariables(fundDataServiceParams)).pipe(
      map((rawHistoricalData) => {
        const moneyFundLiquiditiesDTO: MoneyFundLiquidityDTO[] = rawHistoricalData
          ?.data?.MoneyFundLiquidity?.moneyfundliquidity
          ? rawHistoricalData?.data?.MoneyFundLiquidity?.moneyfundliquidity
          : null;

        const mappperParams: MapperParams = {
          config: this.siteConfigService,
          includeSoftClosed: true,
        };

        const mappedMoneyFundLiquidities: MoneyFundLiquidity[] = this.mapperFactory
          .createMapper(MoneyFundLiquiditiesMapper, mappperParams)
          .toDomain(moneyFundLiquiditiesDTO);

        return mappedMoneyFundLiquidities;
      })
    );
  }

  /**
   * Return required variables value to graphql query.
   * @param fundDataServiceParams params required for graphql query
   */
  private getVariables(
    fundDataServiceParams: FundDataServiceParams
  ): Record<string, any> {
    return {
      countrycode: this.getCountry(),
      languagecode: this.getLanguage(),
      fundid: fundDataServiceParams.fundId,
      shareclasscode: fundDataServiceParams.shareClassCode,
    };
  }
}
